import { Stack } from '@fluentui/react';
import React, { useEffect } from 'react';

// assets

import { useStore } from '../../../stores/root';
import { faHome } from '@fortawesome/pro-light-svg-icons';
import VesselRequisitionForm from '../../../components/vessels/requisitions/general/form';

interface VesselRequisitionFormPageProps {
}

const VesselRequisitionFormPage: React.FC<VesselRequisitionFormPageProps> = (props: VesselRequisitionFormPageProps) => {
    const {user, topbar} = useStore();
    
    useEffect(() => {
        topbar.show('Vessel Requisition Form', [
            {key: 'home', icon: faHome},
            {key: 'vessel requisitions', text: 'Vessel Requisitions'}
        ]);
    }, []);

    return <Stack>
        <VesselRequisitionForm />
    </Stack>;
};

export default VesselRequisitionFormPage;
